import {
    FETCH_ALLOCATION_DATA_START,
    FETCH_ALLOCATION_DATA_FAILURE,
    RENDER_ALLOCATION_DATA
} from "../actions/GridAllocationActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    isError: false,
    gridAllocationData: {}
}

export default function gridAllocationReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_ALLOCATION_DATA_START:
            return {
                ...state,
                loading: true,
                isError: false
            };
        case FETCH_ALLOCATION_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                isError: true
            };
        case RENDER_ALLOCATION_DATA:
            return {
                ...state,
                loading: false,
                gridAllocationData: action.data,
                isError: false
            };
        default:
            // ALWAYS have a default case in a reducer
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/GridAllocationReducer.js